<template>
    <div class="xiangmu">
<!--        <div class="h-crumbOut">-->
<!--            <div class="h-crumbs">-->
<!--                <el-breadcrumb separator="|">-->
<!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--                    <el-breadcrumb-item>-->
<!--                        <a href="/xiangmu/pm">报价管理</a>-->
<!--                    </el-breadcrumb-item>-->
<!--                </el-breadcrumb>-->
<!--            </div>-->
<!--        </div>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30">
            <div class="h-formBox">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
					<div class="h-thirdColumn w-newColumn">
						<el-form-item label="项目名称" class="h-elformWrap-2">
						    <el-input v-model="q.projectName" placeholder="请输入项目名称" clearable></el-input>
						</el-form-item>
						<el-form-item v-if="_user.usertype != 2" label="　供应商名称" class="h-elformWrap-2">
						    <el-input v-model="q.supplierName" placeholder="请输入供应商名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="产品型号" class="h-elformWrap-2">
						    <el-input v-model="q.productName" placeholder="请输入产品型号" clearable></el-input>
						</el-form-item>
						<el-form-item label="产品编码" class="h-elformWrap-2">
							<el-input v-model="q.productId" placeholder="请输入产品编码" clearable></el-input>
						</el-form-item>
					</div>	
					<el-collapse-transition>
						<div v-show="isScreen">
							<div class="h-thirdColumn w-newColumn">
								<el-form-item label="是否采用">
									<brselect style="width:100%;"
									  category="dopick"
									  :v="q.isChosen"
									  clearable
									  v-model="q.isChosen">
									</brselect>
								</el-form-item>
							</div>
						</div>
					</el-collapse-transition>
                </el-form>
				<div class="l-screenBox">
					<div class="l-screen" @click="collapseChange">
						<img :src="isScreen?closeScreen:drawScreen" alt="">
						<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
					</div>
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
					</div>
				</div>
            </div>
        </div>
        <div class="h-table h-mrt30">
            <el-table
                    :span-method="objectSpanMethod"
                    ref="multipleTable"
                    :data="tableData"
                    stripe
					:border="true"
					max-height="430"
                    style="width: 100%">
                <!--@selection-change="handleSelectionChange"-->
                <!--<el-table-column type="selection" width="50" :label="all"></el-table-column>-->
                <el-table-column type="index" label="#" width="40"></el-table-column>
                <el-table-column prop="projectName" label="项目名称" min-width="180" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.projectName}}
						</div>
					</template>
				</el-table-column>
                <el-table-column prop="productName" label="产品型号" mi-width="180" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.productName}}
						</div>
					</template>
				</el-table-column>
                <!--<el-table-column prop="productId" label="产品编码":show-overflow-tooltip="true"></el-table-column>-->
                <el-table-column prop="cuname" label="询价人名称" width="110" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="inquiryTime" label="询价时间" width="160" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column v-if="this._user.usertype != '2' " min-width="180" prop="supplierName" label="供应商名称" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.supplierName}}
						</div>
					</template>
				</el-table-column>
                <el-table-column prop="unitPrice" label="报价金额" width="90" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<div style="text-align: right;">
							{{scope.row.unitPrice}}
						</div>
					</template>
				</el-table-column>
                <el-table-column prop="supplierTime" label="报价时间" width="160" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="isChosen" label="是否采用" width="90" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <dictname category="dopick"  :v="scope.row.isChosen"/>
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-pagination2">
                    <pagination :page="q" @query="query"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from "../../../api/SystemService";
    import updownfile from '../../../utils/updownfile'

    export default {
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //表单
                all: "全部",
                q: {
                    pageSize: 20,
                    pageNo: 1,
                    total: 0,
                },
                //表格
                multipleSelection: [],
                tableData: [],
                proModels: [],
                proCodes: [],
                spanArr: [],
            };
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            // 重置按钮
            resetData() {
                this.q.projectName = ""
                this.q.supplierName = ""
                this.q.productName = ""
                this.q.productId = ""
                this.q.isChosen = ""
                this.q.pageSize = 20
                this.q.pageNo = 1
                this.query()
            },
            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].id === this.tableData[index - 1].id) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (column.label == '项目名称' || column.label == '产品编码' || column.label == '询价人名称') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
            query() {
                ss.ProService.selectQuotePage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                    this.getSpanArr();
                });
            },
            handleFilter() {
                this.query();
            },

        },
        mounted() {
            this.query();
        }
    };
</script>
<style scoped>
    .xiangmu > .h-piece, .h-mrt30 {
        margin: 20px;
        top: 0;
    }
</style>


